define((require) => {
    "use strict";

    var EditorActivity  = require("ui/experience/editor/activity/EditorActivity");
    var WidgetTypes     = require("shared/ui/experience/widgets/WidgetTypes");
    var ProductPropertiesModel = require("ui/experience/widgets/dynamicProductWidget/ProductPropertiesModel");
    var EditorEventFilters = require("ui/editor/EditorEventFilters").default;
    var CreateAndUpdateDynamicProductWidget = require("ui/experience/widgets/dynamicProductWidget/CreateAndUpdateDynamicProductWidget");
    var AddWidgetsAction = require("ui/actions/AddWidgetsAction");

    /**
     * An activity of updating the DynamicProductWidget when a Product ID is entered in
     *
     * We previously marked all activity associated with entering a Product ID as superficial
     * and this activity replaces entering and updating the product ID
     *
     * @class DynamicProductWidgetCreatedActivity
     */
    return EditorActivity.extend({

        widgetType: WidgetTypes.DYNAMIC_PRODUCT.id,

        dynamicProductWidgetModel: null,
        previousDynamicProductWidgetModel: null,
        previousDynamicProductWidgetID: null,
        currentDynamicProductWidgetID: null,
        experience: null,
        _widgetModel: null,
        viewModel: null,
        scene: null,
        viewScope: null,

        model: null,

        constructor: function(options) {
            this.dynamicProductWidgetModel = options.dynamicProductWidgetModel;
            this.previousDynamicProductWidgetModel = options.previousDynamicProductWidgetModel;

            this.previousDynamicProductWidgetID = options.previousID;
            this.currentDynamicProductWidgetID  = options.currentID;

            this._widgetModel = options.dynamicProductWidgetModel;
            this.experience = options.experience;
            this.model = new ProductPropertiesModel();

            this.scene = options.scene;
            this.viewScope = options.viewScope;
        },

        _onUndo: function() {
            // If there is a previous ProductID on the widget,
            // on an undo we change the dynamic Product Widget to show the previous Product ID
            if (this.previousDynamicProductWidgetID) {
                this.model.getProduct(this.previousDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then((product) => {
                    const scene = this.viewScope.viewModel.get("activeLayerSceneModel");
                    const uuid = this.dynamicProductWidgetModel.get("uuid");
                    const correctCurrentWidget = scene.getWidgetByID(uuid);
                    CreateAndUpdateDynamicProductWidget.updateProductWidget(product, this.experience, correctCurrentWidget);
                });
                // else we revert the Product Widget to it's initial single widget state
                // (we so this by replacing the current widget model with a previous model)
            } else {
                CreateAndUpdateDynamicProductWidget.replaceProductWidget(this.scene, this.dynamicProductWidgetModel, this.previousDynamicProductWidgetModel);
            }
        },

        _onRedo: function() {
            // If there is a previous ProductID on the widget,
            // on a redo we change the dynamic Product Widget to show the current Product ID
            if (this.previousDynamicProductWidgetID) {
                this.model.getProduct(this.currentDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then((product) => {
                    const scene = this.viewScope.viewModel.get("activeLayerSceneModel");
                    const uuid = this.dynamicProductWidgetModel.get("uuid");
                    const correctCurrentWidget = scene.getWidgetByID(uuid);
                    CreateAndUpdateDynamicProductWidget.updateProductWidget(product, this.experience, correctCurrentWidget);
                });
            } else {
                // else on a redo, we recreate the DynamicProductWidget with the productID
                this.model.getProduct(this.currentDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then((product) => {
                    CreateAndUpdateDynamicProductWidget.createProductWidget(product, this.experience, this.previousDynamicProductWidgetModel).then((widgetModels) => {
                        // We mark the AddWidgetsAction as SUPERFICIAL to make sure that the activity isn't added to the activity stack
                        new AddWidgetsAction(this.scene, widgetModels, this.viewScope.viewModel, true, {cause: EditorEventFilters.SUPERFICIAL}).execute().done(() => {
                            const scene = this.viewScope.viewModel.get("activeLayerSceneModel");
                            CreateAndUpdateDynamicProductWidget.updateProductWidgetOnScene(scene, this.previousDynamicProductWidgetModel, this.dynamicProductWidgetModel.get("productID"), widgetModels);
                        });
                    });
                });
            }
        },

        dispose: function() {
            this.dynamicProductWidgetModel = null;
            this.previousDynamicProductWidgetModel = null;

            this.previousDynamicProductWidgetID = null;
            this.currentDynamicProductWidgetID  = null;

            this._widgetModel = null;
            this.experience = null;
            this.model = null;

            this.scene = null;
            this.viewScope = null;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/DynamicProductWidgetCreatedActivity.js